$(document).ready(function() {
console.log("persona init slider");
var TotalSlideNum = 6;    
$('#gallery').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear'
  });

  $('input[type="radio"]').click(function(){
        var inputValue = $(this).attr("value");
        var targetBox = $("#persona-" + inputValue);
        $(".description").not(targetBox).hide();
        $(targetBox).show();

   
    });  
   
    $(".btnprev").click(function(){
       var currentLensId = $('input[type=radio][name=slider]:checked').attr('id')
       var slideNumStr = currentLensId.replace("s", "");
        var slideNum = parseInt(slideNumStr);
       console.log("on slideNum", slideNum)
        if (slideNum > 2 && slideNum <= 7){
            var cslideNum  = slideNum - 1  ;
            var curSlideId = "s"+ cslideNum.toString();
            console.log("curSlideId", curSlideId)
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#persona-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();

        
        }else if (slideNum == 2 ){
            var cslideNum  = 7  ;
            var curSlideId = "s"+ cslideNum.toString();
            console.log("curSlideId", curSlideId)
            $('#'+curSlideId).prop("checked", true);
            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#persona-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();
        }
    });
    $(".btnnext").click(function(){
        var currentLensId = $('input[type=radio][name=slider]:checked').attr('id')
        var slideNumStr = currentLensId.replace("s", "");
        var slideNum = parseInt(slideNumStr);
     
       console.log("on slideNum", slideNum)
        if (slideNum > 1 && slideNum < 7){
            var cslideNum  = slideNum + 1 ;
            var curSlideId = "s"+ cslideNum.toString();
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#persona-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();

        }else if (slideNum = TotalSlideNum ){
            var cslideNum  = 2;
            var curSlideId = "s"+ cslideNum.toString();
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#persona-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();
        }
    });


})

